import { Grid, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Bubble } from 'da-frontend-shared-ui-components/lib/Bubble';
import * as colors from 'da-frontend-shared-ui-components/lib/styles/colors';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { useToast } from '../Context/ToastContext';

const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    gridList: {
      ...theme.typography.body2,
      padding: "1em 0 1em 0",
      
      "& svg": {
        verticalAlign: "text-bottom",
        marginRight: ".3em"
      },

      "& .tile": {
        display: "block",
        padding: "14px",
        outline: "1px solid #979797",
        minWidth: "225px",
        backgroundColor: "#FFF",
        color: "#000",
        transition: "background-color .2s",
        position: "relative",
        userSelect: "none",

        "&:hover": {
          backgroundColor: "#EEE"
        },

        "&.selected": {
          backgroundColor: colors.grayMed,
          color: "#FFF",
          outline: "none",

          "& svg path": {
            fill: "#FFF"
          }
        },

        "&.disabled": {
          opacity: 0.5,
          cursor: "default"
        }
      },
    }
  })
);

type TileProps = {
  icon: React.ReactNode
  children: React.ReactNode
  to?: string
  selected?: boolean
  isEnabled?: boolean
  bubbleValue?: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
};


const Tile = ({ icon, children, bubbleValue: count, to=null, selected=false, isEnabled=true, ...props }: TileProps) => {
  const { t }         = useTranslation();
  const { sendToast } = useToast();

  const onDisabledClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    
    sendToast(t`errors.Inactive account`);
  }, [ t, sendToast ]);

  return (
  <Grid item>
    <NavLink
      to={to} 
      activeClassName="selected"
      className={"tile" + (selected ? " selected" : "") + (isEnabled ? "": " disabled")}
      {...isEnabled ? {} : { onClick: onDisabledClick }}
      {...props}>
      {icon}
      {children}
      {count && <Bubble value={count} />}
    </NavLink>
  </Grid>
  )
}

/**
 * Tile navigation menu system
 */
const Tiles: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={24} className={classes.gridList}>
      {children}
    </Grid>
  );
}

export default Tiles

export { Tile };
